var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-sheet',{attrs:{"value":_vm.updateExists}},[_c('v-sheet',{staticClass:"text-center pa-4",attrs:{"height":"120px"}},[_vm._v(" Yπάρχει διαθέσιμη αναβάθμιση "),_c('div',{staticClass:"py-3"},[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.refreshApp}},[_vm._v(" Update ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }